
<template>
  <v-form @submit="submitForm">
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12">
          <v-text-field
            data-test-id="code"
            v-model="code"
            name="code"
            type="text"
            clearable
            prepend-icon="mdi-ticket-percent"
            label="Premium-Code"
            :append-outer-icon="'mdi-send'"
            @click:append-outer="activateCoupon"
            :disabled="loading"
            :loading="loading"
            hint="Eingabebereich für einen Premium-Coupon-Code"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import {
  MUTATION_DISMISS_NOTIFICATION,
  MUTATION_RAISE_NOTIFICATION
} from "@/plugins/store.js";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";

export default {
  name: "PremiumCouponForm",
  props: {},
  data: () => ({
    valid: false,
    loading: false,
    code: undefined,
  }),
  computed: {
    filled() {
      return this.code && this.code.length > 0;
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    submitForm(e) {
      e.preventDefault();
      if (this.filled) {
        this.activateCoupon();
      }
      return false
    },
    activateCoupon() {
      this.loading = true;
      this.$store.commit(MUTATION_DISMISS_NOTIFICATION);
      console.log("Submitting coupon code");
      this.$api
        .activatePremiumCouponCode(this.code)
        .then(() => {
          this.loading = false;
          this.resetForm();
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: "Premium-Code erfolgreich aktiviert!"
          });
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
          // this.$store.dispatch(ACTION_RELOAD_DATA);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    resetForm() {
      this.code = undefined;
    }
  }
};
</script>